import { render, staticRenderFns } from "./OzonView.vue?vue&type=template&id=21b26adf"
import script from "./OzonView.vue?vue&type=script&lang=ts"
export * from "./OzonView.vue?vue&type=script&lang=ts"
import style0 from "./OzonView.vue?vue&type=style&index=0&id=21b26adf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports